import { render, staticRenderFns } from "./ReleaseNei.vue?vue&type=template&id=1b7c0fcf&scoped=true"
import script from "./ReleaseNei.vue?vue&type=script&lang=js"
export * from "./ReleaseNei.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNei.vue?vue&type=style&index=0&id=1b7c0fcf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7c0fcf",
  null
  
)

export default component.exports